// extracted by css-extract-rspack-plugin
export default {"suggestWrapperStyled":"suggestWrapperStyled-e2mh06"};